import React from 'react';

const variantMap = {
  primary: 'ds-btn-primary',
  secondary: 'ds-btn-secondary',
  ghost: 'ds-btn-ghost',
  energy: 'ds-btn-energy',
  success: 'ds-btn-success',
  info: 'ds-btn-info',
  purple: 'ds-btn-purple',
  danger: 'ds-btn-danger',
};

export default function DSButton({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  loading = false,
  disabled = false,
  className = '',
  as: Tag = 'button',
  ...props
}) {
  const base = variantMap[variant] || variantMap.primary;
  const cls = [
    base,
    size === 'lg' && `${base}--lg`,
    size === 'sm' && `${base}--sm`,
    fullWidth && `${base}--full`,
    className,
  ].filter(Boolean).join(' ');

  return (
    <Tag className={cls} disabled={disabled || loading} {...props}>
      {loading && <span className="ds-btn__spinner" aria-hidden="true" />}
      {children}
    </Tag>
  );
}
